const divModalEquipCheckList = {
  groupQuestionArray: 'Checklist no questions added'
};

export default divModalEquipCheckList;
